import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import settings from '/@/core/settings';
import FieldviewLogoUrl from '/@/styles/assets/social/fieldview.svg?url';
import CultivioLogoUrl from './assets/Cultivio_Logo.svg?url';
import styles from './styles.module.css';
@autobind
export default class AppLogo extends Component {
    static propTypes = {
        className: PropTypes.string,
        classNameImage: PropTypes.string,
    };

    srcLogo() {
        if (settings.app.theme === 'fieldview') {
            return FieldviewLogoUrl;
        }
        if (settings.app.theme === 'cultivio') {
            return CultivioLogoUrl;
        }
        return settings.app.logo;
    }

    render() {
        return (
            <div className={classNames(styles.root, this.props.className)}>
                <img
                    className={classNames(styles.image, this.props.classNameImage, {
                        [styles.fieldview]: settings.app.theme === 'fieldview',
                    })}
                    src={this.srcLogo()}
                    alt={settings.app.name}
                />
            </div>
        );
    }
}
